import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { StickerArt, STICKER_GROUPS } from "./StickerArt";

export const STICKER_DND_TYPE = "application/litmap-sticker";

export default function StickerTray({ onAdd }) {
  const [open, setOpen] = useState(() => typeof window === "undefined" || window.innerWidth >= 640);
  return (
    <div
      data-testid="sticker-tray"
      className="bg-white/90 backdrop-blur-md border-2 border-[#F5D0E3] rounded-3xl shadow-[0_10px_30px_rgba(201,40,111,0.12)] w-[176px] overflow-hidden"
    >
      <button
        data-testid="sticker-tray-toggle"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between px-4 py-2.5 font-serif-display text-base font-semibold text-[#3B2350] hover:bg-[#FDF2F8] transition-colors"
      >
        Stickers
        {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
      {open && (
        <div className="px-3 pb-3">
          <p className="text-xs text-[#5E4B70] mb-2 leading-snug">Tap or drag one onto your map</p>
          <div data-testid="sticker-tray-list" className="grid grid-cols-3 gap-1.5 max-h-[min(52vh,420px)] overflow-y-auto pr-1 -mr-1">
            {STICKER_GROUPS.map((g) => [
              <div key={g.label} data-testid={`sticker-group-${g.label.split(" ")[0].toLowerCase()}`} className="col-span-3 font-serif-display text-sm font-semibold text-[#C9286F] pt-2 first:pt-0">
                {g.label}
              </div>,
              ...g.kinds.map((k) => (
              <button
                key={k}
                data-testid={`sticker-option-${k}`}
                title={k.replace("pixel_", "pixel ")}
                aria-label={`Add ${k} sticker`}
                draggable
                onDragStart={(e) => {
                  e.dataTransfer.setData(STICKER_DND_TYPE, k);
                  e.dataTransfer.effectAllowed = "copy";
                }}
                onClick={() => onAdd(k)}
                className="hover-wiggle aspect-square p-1.5 rounded-2xl bg-[#FDF2F8] hover:bg-[#FCE7F3] hover:scale-110 active:scale-95 transition-transform cursor-grab"
              >
                <StickerArt kind={k} />
              </button>
              )),
            ])}
          </div>
        </div>
      )}
    </div>
  );
}
